import { EArticleClass, EPostSeoBanStatus, IGalleryArticleDetail, TArticleDetail } from 'shared/models/article/article';
import { Region } from '@lemon8/web-app-shared/i18n';
import { EArticleUnavailableReason, IArticleUnavailableDetail } from './article-unavailable';
import { ArticleJsonLDUtil } from 'shared/models/article/json-ld-util';
import { UserTypeUtil } from '../#common';
import { Article, IImage } from '..';

export const ArticleDetailUtil = {
  isArticleAvailable: (article: IArticleUnavailableDetail | TArticleDetail): article is TArticleDetail => {
    return !('unavailableReason' in article);
  },
  shouldNoindex: (article: IArticleUnavailableDetail | TArticleDetail): boolean => {
    return ArticleDetailUtil.isArticleAvailable(article) && article.seoBan === EPostSeoBanStatus.Deindex;
  },
  isBotDeindexUnavailablePage: (article: IArticleUnavailableDetail | TArticleDetail): boolean => {
    return (
      !ArticleDetailUtil.isArticleAvailable(article) && article.unavailableReason === EArticleUnavailableReason.DEINDEX
    );
  },
  shouldEmitNoindex: (article: IArticleUnavailableDetail | TArticleDetail): boolean => {
    return ArticleDetailUtil.shouldNoindex(article) || ArticleDetailUtil.isBotDeindexUnavailablePage(article);
  },
  /**
   * article has translated version
   */
  hasTranslatedVersion: (article: TArticleDetail): boolean => {
    const { translatedRegions = [] } = article;
    return translatedRegions.length !== 0;
  },
  /**
   * article is translated, and translated version is needed to show
   */
  isTranslatedArticleToShow: (article: TArticleDetail, _region: Region): boolean => {
    const { isTranslatedVersion = false } = article;
    return isTranslatedVersion;
  },

  getArticlePath: (article: TArticleDetail): string => {
    return `/${UserTypeUtil.getLinkNamePrefix(article.author.userType)}${article.author.linkName}/${article.groupId}`;
  },

  getArticleHref: (article: TArticleDetail, translatedRegion?: Region): string => {
    return `${ArticleDetailUtil.getArticlePath(article)}?region=${translatedRegion || article.articleRegion}`;
  },

  getAuthorPath: (article: TArticleDetail): string => {
    return `/${UserTypeUtil.getLinkNamePrefix(article.author.userType)}${article.author.linkName}`;
  },

  getAuthorHref: (article: TArticleDetail, translatedRegion?: Region): string => {
    return `/${UserTypeUtil.getLinkNamePrefix(article.author.userType)}${article.author.linkName}?region=${
      translatedRegion || article.articleRegion
    }`;
  },

  getCoverImage: (article: TArticleDetail | Article): IImage => {
    switch (article.articleClass) {
      case EArticleClass.GALLERY:
        return (article as IGalleryArticleDetail).imageList[0];
      case EArticleClass.ARTICLE:
      case EArticleClass.VIDEO:
      default:
        return article.largeImage;
    }
  },

  JsonLD: ArticleJsonLDUtil,
};
